import { Injectable } from '@angular/core';
import { CustomFormUtilsService } from './../../custom-form-utils.service';

@Injectable({
  providedIn: 'root'
})
export class CustomEventService {

  traFAgr = {"sum":" Suma de los valores del atributo ","count":" Cuenta de los elementos del campo "}

  constructor(private customFormUtilsService:CustomFormUtilsService) {
  }

/**
   * Valida la expresión introducida
*/
  public async validaExpresion(expre): Promise<{ vExprValida: boolean, vTraduccion: string }> {
    let traduccion = "El atributo "
    let operadoresRegex = /(\+=|-=|=)/g;
    let traOperadores = {"+=":" aumentará con el valor resultante de la operación ","-=":" disminuirá con el valor resultante de la operación ","=":" será igual al valor resultante de la operación "}
    let traOper = {"+":" + ","-":" - ","/":" / ","*":" * "}
    let opParaCalcRegex = /(\+|\-|\*|\/)/g;

    // comprobar que los paréntesis están bien balanceados
    let parentesis = 0;
    for (let i = 0; i < expre.length; i++) {
      if (expre[i] === '(') {
        parentesis++;
      } else if (expre[i] === ')') {
        parentesis--;
      }
    }
    if (parentesis !== 0) {
      let vExprValida = false;
      let vTraduccion = "ERROR: No hay el mismo número de paréntesis de apertura que de cierre"
      return { vExprValida, vTraduccion };
    }
    // comprobar que los corchetes están bien balanceados
    let corchetes = 0;
    for (let i = 0; i < expre.length; i++) {
      if (expre[i] === '[') {
        corchetes++;
      } else if (expre[i] === ']') {
        corchetes--;
      }
    }
    if (corchetes !== 0) {
      let vExprValida = false;
      let vTraduccion = "ERROR: No hay el mismo número de corchetes de apertura que de cierre"
      return { vExprValida, vTraduccion };
    }

    expre = expre.toString().replace(/\(|\)/g, '');

    // buscar los operadores permitidos
    let operadores = expre.match(operadoresRegex);

    if (operadores == null) {
      let vExprValida = false;
      let vTraduccion = "ERROR: Falta uno de los operadores permitidos (+=, -=, =)"
      return { vExprValida, vTraduccion };
    } else if (operadores.length != 1){
      let vExprValida = false;
      let vTraduccion = "ERROR: Sólo puede haber un operador de asignación permitido"
      return { vExprValida, vTraduccion };
    }else{
      //Como sólo puede haber un operador, sólo habrá 2 "palabras"
      let palabras = expre.trim().split(operadores[0])
      for (let i = 0; i< palabras.length; i++) {
        if (palabras[i].trim() == ""){
          let vExprValida = false;
          if (i == 0){
            let vTraduccion = "ERROR: La expresión para el atributo objetivo no puede estar vacía"
            return { vExprValida, vTraduccion };
          } else if (i == 1){
            let vTraduccion = "ERROR: La expresión para el cálculo valor no puede estar vacía"
            return { vExprValida, vTraduccion };
          }
        }
      }
      let atributoObjetivo = palabras[0]
      let calculoValor = palabras[1]
      //En el atributoObjetivo sólo puede haber un '.' y lo que haya detrás de él
      //tiene que ser un atributo del elemento de la entidad
      //Además el atributoObjetivo no puede contener ninguna función de agrupación
      //ni ningún operador matemático sencillo

      let res = await this.objAtrDeElem (traduccion, atributoObjetivo)
      if (res.slice(0,5) == "ERROR"){
        let vExprValida = false;
        let vTraduccion = res.toString();
        return { vExprValida, vTraduccion };
      }else{
        traduccion = res + traOperadores[operadores[0]]
      }

      // buscar los operadores de operaciones básicas permitidos para el cálculo del valor
      operadores = calculoValor.match(opParaCalcRegex);
      if (operadores == null) {
        //La segunda parte de la expresión es un valor sin operadores
        if (calculoValor.indexOf('sum') != -1 ){
          res = (await this.validaSumCount(calculoValor, 'sum'))
          if (res.slice(0,5) == "ERROR"){
            let vExprValida = false;
            let vTraduccion = res.toString();
            return { vExprValida, vTraduccion };
          }else{
            traduccion = traduccion + res
          }
        }else if (calculoValor.indexOf('count') != -1){
          res = (await this.validaSumCount(calculoValor, 'count'))
          if (res.slice(0,5) == "ERROR"){
            let vExprValida = false;
            let vTraduccion = res.toString();
            return { vExprValida, vTraduccion };
          }else{
            traduccion = traduccion + res
          }
        }else{
          //El operando tiene que ser un número o un atributo de tipo numérico
          //Si en el atributo hay un punto, se entiende que es un atributo de la entidad
          //indicada en el campo de tipo subformulario
          if (!isNaN(Number(calculoValor))){
            traduccion = traduccion + calculoValor
          }else{
            res = await this.compruebaAtributo(calculoValor, traduccion)
            if (res.slice(0,5) == "ERROR"){
              let vExprValida = false;
              let vTraduccion = res.toString();
              return { vExprValida, vTraduccion };
            }else{
              traduccion = res.toString()
            }
          }
        }
      }else{
        //Al menos hay un operador matemático
        let val = calculoValor
        let numOperadores = operadores.length
        if (val.trim().indexOf(operadores[0]) == 0){
          let vExprValida = false;
          let vTraduccion = "ERROR: Tiene que haber un valor entre el operador de asignación y el operador matemático"
          return { vExprValida, vTraduccion };
        }
        //Antes del bucle, se trata el primer operando
        let oper = val.slice(0, val.indexOf(operadores[0]) + operadores[0].length - 1).trim();
        if (oper.indexOf('sum') != -1){
          res = (await this.validaSumCount(oper, 'sum'))
          if (res.slice(0,5) == "ERROR"){
            let vExprValida = false;
            let vTraduccion = res.toString();
            return { vExprValida, vTraduccion };
          }else{
            traduccion = traduccion + res
          }
        }else if (oper.indexOf('count') != -1){
          res = (await this.validaSumCount(oper, 'count'))
          if (res.slice(0,5) == "ERROR"){
            let vExprValida = false;
            let vTraduccion = res.toString();
            return { vExprValida, vTraduccion };
          }else{
            traduccion = traduccion + res
          }
        }else{
          //El operando tiene que ser un número o un atributo de tipo numérico
          //Si en el atributo hay un punto, se entiende que es un atributo de la entidad
          //indicada en el campo de tipo subformulario
          if (!isNaN(Number(oper))){
            traduccion = traduccion + oper
          }else{
            res = await this.compruebaAtributo(oper, traduccion)
            if (res.slice(0,5) == "ERROR"){
              let vExprValida = false;
              let vTraduccion = res.toString();
              return { vExprValida, vTraduccion };
            }else{
              traduccion = res.toString()
            }
          }
        }

        for (let i = 0; i< numOperadores; i++) {
          //Se pinta el operador
          traduccion = traduccion + traOper[operadores[0]]
          //Nos quedamos con lo siguiente desde el operador hasta el final de la cadena
          val = val.slice(val.indexOf(operadores[0]) + operadores[0].length).trim();
          if (val != ""){
            operadores = val.match(opParaCalcRegex);
            if (operadores != null){
              //Hay más operadores. El operadores[0] será el que se pinte en la siguiente iteración
              if (val.substring(0,1) == operadores[0]){
                //Hay 2 operadores seguidos
                let vExprValida = false;
                let vTraduccion = "ERROR: No se pueden escribir 2 operadores matemáticos seguidos";
                return { vExprValida, vTraduccion };
              }
              //Siguiente operando, antes del siguiente operador
              oper = val.slice(0, val.indexOf(operadores[0]) + operadores[0].length - 1).trim();
            }else{
              //Último operando
              oper = val
            }
            if (oper.indexOf('sum') != -1){
              res = (await this.validaSumCount(oper, 'sum'))
              if (res.slice(0,5) == "ERROR"){
                let vExprValida = false;
                let vTraduccion = res.toString();
                return { vExprValida, vTraduccion };
              }else{
                traduccion = traduccion + res
              }
            }else if (oper.indexOf('count') != -1){
              res = (await this.validaSumCount(oper, 'count'))
              if (res.slice(0,5) == "ERROR"){
                let vExprValida = false;
                let vTraduccion = res.toString();
                return { vExprValida, vTraduccion };
              }else{
                traduccion = traduccion + res
              }
            }else{
              //El operando tiene que ser un número o un atributo de tipo numérico
              //Si en el atributo hay un punto, se entiende que es un atributo de la entidad
              //indicada en el campo de tipo subformulario
              if (!isNaN(Number(oper))){
                traduccion = traduccion + oper
              }else{
                res = await this.compruebaAtributo(oper, traduccion)
                if (res.slice(0,5) == "ERROR"){
                  let vExprValida = false;
                  let vTraduccion = res.toString();
                  return { vExprValida, vTraduccion };
                }else{
                  traduccion = res.toString()
                }
              }
            }
          }else{
            let vExprValida = false;
            let vTraduccion = "ERROR: Falta un operando después del último operador";
            return { vExprValida, vTraduccion };
          }
        }
      }
      let vExprValida = true;
      let vTraduccion = traduccion
      return { vExprValida, vTraduccion };
    }
  }

  public async objAtrDeElem (trad, expr): Promise<String>{
    if (expr.indexOf("element[") == -1){
      return "ERROR: En el atributo objetivo, el identificador del elemento del customform debe ir entre corchetes, dentro de la expresión 'element[]'"
    }
    //idElem debe existir en la lista de identificadores de campos del customform
    let idElem = expr.slice(expr.indexOf("[") + 1, expr.indexOf("]")).trim()
    if (idElem == ""){
      return "ERROR: En el atributo objetivo, el identificador del elemento del customform no se ha especificado"
    }

    if (expr.indexOf(".") == -1){
      return "ERROR: En el atributo objetivo, no se ha especificado atributo de la entidad personalizada, debe ir detrás de un '.'"
    }
    if (expr.indexOf("].") == -1){
      return "ERROR: En el atributo objetivo, después de ']' debe ir un '.'"
    }
    //atributoAModificar debe existir en la lista de atributos de la entidad personalizada

    //Obtenemos la entidad para verificar que el atributo indicado existe
    try {
      var entidad = (await this.customFormUtilsService.getEntityFromField(idElem));
    } catch (error) {
      return "ERROR: " + error;
    }
    var atributosEntidad:[any] = entidad.attributes.filter(a => a['type'] == 'number') as [any]
    let atributoAModificar =  expr.slice(expr.lastIndexOf(".") + 1).trim();
    if (atributoAModificar == ""){
      return "ERROR: En el atributo objetivo, detrás de un '.' se debe especificar un atributo de la entidad personalizada"
    }else if(atributosEntidad.find(a => a.id == atributoAModificar) == undefined){
      return `ERROR: En el atributo objetivo, el atributo de tipo 'number' ${atributoAModificar} no existe en la entidad ${entidad.name} (${atributosEntidad.map(a => a.id)})`
    }
    return trad + atributoAModificar + " del elemento del campo " + idElem;
  }


  public async sumAtrDeElem (trad, expr):Promise<String>{
    let vLabel = ""
    if (trad != ""){
      vLabel = "En el valor del cálculo para la función SUM, "
    }
    if (expr.indexOf("element[") == -1){
      return "ERROR: " + vLabel + "el identificador del elemento de la entidad personalizada debe ir entre corchetes, dentro de la expresión 'element[]'"
    }
    //idElem debe existir en la lista de identificadores de campos del customform
    //O puede ser un campo de un subformulario, que va detrás de X.
    let idElem = expr.slice(expr.indexOf("[") + 1, expr.indexOf("]")).trim()
    let despuesPunto = ""
    let antesPunto = "" //X en el evolutivo, para traducir "de cada X"
    if (idElem == ""){
      return "ERROR: " + vLabel + "el identificador del elemento de la entidad personalizada no se ha especificado"
    }else if (idElem.trim().indexOf(".") == 0){
      return "ERROR: " + vLabel + "el '.' no puede ser el primer carácter de un identificador de elemento de la entidad personalizada"
    }else if (idElem.indexOf(".") > 0){
      //Tiene que haber texto antes y después del punto
      // antesPunto es un campo del customform de tipo subform
      antesPunto = idElem.slice(0, idElem.indexOf('.')).trim();
      if (antesPunto == ""){
        return "ERROR: " + vLabel + "no hay nada antes del punto"
      }else {
        //Obtenemos el subform para verificar que el atributo indicado existe
        try {
          //Si es un atributo de un subformulario, coge lo que hay después del punto para la comprobación
          var entitiesListFromSubform = (await this.customFormUtilsService.getSubformFromField(antesPunto, "customentity_list"))
          if (entitiesListFromSubform == ""){
            return "ERROR: " + vLabel + "no hay campos de tipo customentitylist del subformulario " + antesPunto
          }
        } catch (error) {
          return "ERROR: " + error
        }
      }
      // despuesPunto es un campo de tipo customentitylist de ese subformulario, recuperado en el try anterior
      despuesPunto = idElem.slice(idElem.indexOf('.') + 1).trim();
      if (despuesPunto == ""){
        return "ERROR: " + vLabel + "dentro de los [] un '.' no puede ser el último carácter, hay que especificar un campo de tipo customentitylist del subformulario antes del punto"
      }else {
        //Comprobamos que el campo de tipo customentity_list del subform indicado existe
        if (!entitiesListFromSubform.includes(despuesPunto)) {
          return "ERROR: " + vLabel + "el valor " + despuesPunto + " tiene que ser un campo de subformulario de tipo 'customentity_list' (" + entitiesListFromSubform + ")"
        }
      }
    }else if (idElem.indexOf(".") == -1){
      //Obtenemos la entidad para verificar que el atributo indicado existe
      try {
        //Si es un atributo de un subformulario, coge lo que hay después del punto para la comprobación
        var entidad = (await this.customFormUtilsService.getEntityFromField(idElem.split(".")[1] || idElem))
      } catch (error) {
        return "ERROR: " + error
      }
    }
    if (expr.indexOf(".") == -1){
      return "ERROR: " + vLabel + "no se ha especificado atributo de la entidad personalizada, debe ir detrás de un '.'"
    }
    if (expr.indexOf("].") == -1){
      return "ERROR: " + vLabel + "después de ']' debe ir un '.'"
    }
    var entidadSubform
    if (despuesPunto != ""){// Va un atributo de la entidad del campo de tipo subform
      entidadSubform = (await this.customFormUtilsService.getCompanyEntities())
      try {
        var idSubform = (await this.customFormUtilsService.getIdSubformFromField(antesPunto))
      } catch (error) {
        return "ERROR: " + error
      }
      if (!(entidadSubform.some(b => b.id === idSubform))){
        return "ERROR: " + vLabel + "no existe la entidad " + idSubform
      }else{
        entidadSubform = entidadSubform.filter(a => a.id == idSubform)
      }
    }
    if (entidadSubform != undefined) {
      entidad = entidadSubform[0]
    }
    //atributoAModificar debe existir en la lista de atributos de la entidad personalizada y debe ser de tipo 'number'
    var atributosEntidad:[any] = entidad.attributes.filter(a => a['type'] == 'number') as [any]
    let atributoAModificar = expr.substring(expr.indexOf("]") + 1).trim();
    atributoAModificar = atributoAModificar.slice(atributoAModificar.indexOf(".") + 1).trim();
    if (atributoAModificar == ""){
      return "ERROR: " + vLabel + "detrás de un '.' se debe especificar un atributo objetivo"
    }else if(atributosEntidad.find(a => a.id == atributoAModificar) == undefined){
      return `ERROR: ` + vLabel + `el atributo de tipo 'number' ${atributoAModificar} no existe en la entidad ${entidad.name} (${atributosEntidad.map(a => a.id)})`
    }
    if (despuesPunto == ""){
      return trad + atributoAModificar + " de los elementos del campo " + idElem;
    }else{
      return trad + atributoAModificar + " de los elementos del campo " + despuesPunto + " de cada " + antesPunto;
    }
  }

  public async countAtrDeElem (trad, expr): Promise<String>{
    if (expr.indexOf("element[") == -1){
      return "ERROR: El identificador del elemento de la entidad personalizada en la función COUNT debe ir entre corchetes, dentro de la expresión 'element[]'"
    }
    //idElem debe existir en la lista de identificadores de campos del customform
    //O puede ser un campo de un subformulario, que va detrás de X.
    let idElem = expr.slice(expr.indexOf("[") + 1, expr.indexOf("]")).trim()
    let despuesPunto = ""
    let antesPunto = ""
    if (idElem == ""){
      return "ERROR: El identificador del elemento del customform en la función COUNT no se ha especificado"
    }else if (idElem.trim().indexOf(".") == 0){
      return "ERROR: El '.' no puede ser el primer carácter de un identificador de elemento de la entidad personalizada en la función COUNT"
    }else if (idElem.indexOf(".") > 0){
      //Tiene que haber texto antes y después del punto
      // antesPunto es un campo del customform de tipo subform
      antesPunto = idElem.slice(0, idElem.indexOf('.')).trim();
      if (antesPunto == ""){
        return "ERROR: Dentro de los [] en la función COUNT, no hay nada antes del punto"
      }else {
        //Obtenemos el subform para verificar que el atributo indicado existe
        try {
          //Si es un atributo de un subformulario, coge lo que hay después del punto para la comprobación
          var entitiesListFromSubform = (await this.customFormUtilsService.getSubformFromField(antesPunto, "customentity_list"))
          if (entitiesListFromSubform == ""){
            return "ERRORDentro de los [] en la función COUNT, no hay campos de tipo customentitylist del subformulario " + antesPunto
          }
        } catch (error) {
          return "ERROR: " + error
        }
      }
      // despuesPunto es un campo de tipo customentitylist de ese subformulario, recuperado en el try anterior
      despuesPunto = idElem.slice(idElem.indexOf('.') + 1).trim();
      if (despuesPunto == ""){
        return "ERROR: Dentro de los [] en la función COUNT, un '.' no puede ser el último carácter, hay que especificar un campo de tipo customentitylist del subformulario antes del punto"
      }else {
        //Comprobamos que el campo de tipo customentity_list del subform indicado existe
        if (!entitiesListFromSubform.includes(despuesPunto)) {
          return "ERROR: Dentro de los [] en la función COUNT, el valor " + despuesPunto + " tiene que ser un campo de subformulario de tipo 'customentity_list' (" + entitiesListFromSubform + ")"
        }
      }
    }else if (idElem.indexOf(".") == -1){
      //Obtenemos la entidad para verificar que el atributo indicado existe
      try {
        //Si es un atributo de un subformulario, coge lo que hay después del punto para la comprobación
        var entidad = (await this.customFormUtilsService.getEntityFromField(idElem.split(".")[1] || idElem))
      } catch (error) {
        return "ERROR: " + error
      }
    }

    let ultimoCaracter = expr.charAt(expr.length - 1);
    if (ultimoCaracter != "]"){
      return "ERROR: En la función COUNT, el último carácter debe ser un ']'"
    }
    if (despuesPunto == ""){
      return trad + idElem;
    }else{
      return trad + despuesPunto + " de cada " + antesPunto;
    }
  }

  async compruebaTipo(vValor){
    let listaIdElemNum = await this.customFormUtilsService.getFormFieldTypeList();
    listaIdElemNum = listaIdElemNum.filter(e => e.type === "number").map(a => a.id)

    //Comprobar que es alguno de los campos del customform, si no incluye '.'
    if (vValor.indexOf(".") == -1){
      if (!listaIdElemNum.includes(vValor)) {
        return "ERROR: En la expresión para el cálculo valor, el valor " + vValor + " tiene que ser un campo de formulario de tipo 'number' (" + listaIdElemNum + ")"
      }else{
        return ""
      }
    }

    let despuesPunto = ""
    let antesPunto = ""
    if (vValor.indexOf(".") == 0){
      return "ERROR: En la expresión para el cálculo valor, el '.' no puede ser el primer carácter de un operando"
    }else if (vValor.indexOf(".") > 0){
      //Tiene que haber texto antes y después del punto
      // antesPunto es un campo del customform de tipo subform
      antesPunto = vValor.slice(0, vValor.indexOf('.')).trim();
      if (antesPunto == ""){
        return "ERROR: En la expresión para el cálculo valor, no hay nada antes del punto"
      }else {
        //Obtenemos el subform para verificar que el atributo indicado existe
        try {
          //Si es un atributo de un subformulario, coge lo que hay después del punto para la comprobación
          var entitiesListFromSubform = (await this.customFormUtilsService.getSubformFromField(antesPunto, "number"))
          if (entitiesListFromSubform == ""){
            return "ERROR: En la expresión para el cálculo valor, no hay campos de tipo customentitylist del subformulario " + antesPunto
          }
        } catch (error) {
          return "ERROR: " + error
        }
      }
      // despuesPunto es un campo de tipo customentitylist de ese subformulario, recuperado en el try anterior
      despuesPunto = vValor.slice(vValor.indexOf('.') + 1).trim();
      if (despuesPunto == ""){
        return "ERROR: En la expresión para el cálculo valor, un '.' no puede ser el último carácter de un operando"
      }else{
        //Comprobamos que el campo de tipo customentity_list del subform indicado existe
        if (!entitiesListFromSubform.includes(despuesPunto)) {
          return "ERROR: En la expresión para el cálculo valor, el valor " + despuesPunto + " tiene que ser un campo de subformulario de tipo 'customentity_list' (" + entitiesListFromSubform + ")"
        }else{
          return despuesPunto + " de cada " + antesPunto
        }
      }
    }
  }

  public async validaSumCount(vOper, valor){
    if (vOper.trim().indexOf(valor) != 0){
      return "ERROR: Hay algo escrito antes de " + valor.toUpperCase() + " que no es un operador"
    }
    if (valor == 'sum'){
      return await this.sumAtrDeElem (this.traFAgr[valor], vOper)
    }else{
      return await this.countAtrDeElem (this.traFAgr[valor], vOper)
    }
  }

  public async compruebaAtributo(valor, trad){
    let res
    if (valor.trim().indexOf("element[") == 0){
      res = await this.sumAtrDeElem ("", valor)
      if (res.slice(0,5) == "ERROR"){
        return res
      }else{
        return trad + res
      }
    }else{
      res = await this.compruebaTipo(valor.trim())
      if (res == ""){
        return trad + valor
      }else if (res.slice(0,5) == "ERROR"){
        return res
      }else{
        return trad + res
      }
    }
  }
}


